import o from "@babel/runtime/helpers/esm/slicedToArray";
import c from "react";
import m from "@semcore/utils/lib/use/useEnhancedEffect";
import R from "@semcore/utils/lib/canUseDOM";
var z = function(r, e) {
  var i = c.useState(0), n = o(i, 2), s = n[0], u = n[1], a = c.useCallback(function(t) {
    u(t[0].contentRect.width);
  }, []);
  return m(function() {
    if (r.current && !e && R()) {
      var t = new ResizeObserver(function(f) {
        a(f);
      });
      return t.observe(r.current), function() {
        t.disconnect();
      };
    }
  }, [e]), e || {
    width: s
  };
};
export {
  z as useResizeObserver
};
